import axiosInstance from "@/axiosInterceptor";
import { Eventbus } from "@/plugins/eventBus";

export async function saveDraft(payload, redirection = undefined) {
    try {
        let response = await axiosInstance.put(`/pr/saveDraft`, payload)
        if (response.status === 200) {
            const results = {
                success: true,
                data: {
                    title: 'PR saved as Draft',
                    image: require('@/assets/icons/success.svg'),
                    type: 'success'
                }
            };
            return results;
        } else {
            throw new Error("Non-200 status");
        }



    } catch (error) {
        Eventbus.emit('commonSnackbar', {
            snackType: "save",
            message: 'Failed to save draft'
        });
        return false;
    }
}
